import cx from 'classnames';
import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom-v5-compat';
import Button, { ButtonProps } from '../Button/index.js';
import Icon from '../Icon/index.js';

export function NavButtons({ children }: { children: ReactNode }): JSX.Element {
  return <div className="h-full flex items-center gap-x-6">{children}</div>;
}

export function HelpButton({ link }: { link: string }): JSX.Element {
  return (
    <NavButton link={link} target="_blank" external>
      {/* Can't use the icon prop on the Button because we need to hide the text on mobile
          and spacing would get weird */}
      <span className="flex items-center lg:gap-2">
        <Icon type="help" size="LG" />
        <span className="hidden lg:inline">Help</span>
      </span>
    </NavButton>
  );
}

export default function NavButton(props: ButtonProps): JSX.Element {
  if (props.link && !props.external)
    return (
      <NavLink
        to={props.link}
        className={({ isActive }) =>
          cx(
            'h-full flex items-center font-semibold uppercase border-b-4 hover:border-brand',
            isActive ? 'border-brand' : 'border-transparent',
          )
        }
        end
      >
        {props.children}
      </NavLink>
    );

  return (
    <Button
      {...props}
      variant="text"
      className="h-full border-b-4 border-transparent hover:border-brand"
    />
  );
}
